import { render, staticRenderFns } from "./inputFileProcessorNewVersion.vue?vue&type=template&id=7b96f1e6&"
import script from "./inputFileProcessorNewVersion.vue?vue&type=script&lang=js&"
export * from "./inputFileProcessorNewVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports